module.exports = __webpack_public_path__ + "img/wwen.17c99f6b.png";